import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: #f0f0f0;
    --secondary-color: #a9a9b3;
    
    --background-start: #0a021c; /* Biraz daha koyu */
    --background-mid: #0d0426;   /* Yeni bir ara renk */
    --background-end: #000000;
    --gradient-purple: #8a2be2;
    --gradient-pink: #ff007f;
    --gradient-cyan: #00f2ff;

    --button-bg-start: #8a2be2;
    --button-bg-end: #ff007f;
    --sidebar-indicator-color: #ff007f;

    --glass-bg: rgba(20, 10, 30, 0.6);
    --border-color: rgba(255, 255, 255, 0.1);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  body {
    background: linear-gradient(135deg, var(--background-start), var(--background-mid), var(--background-end));
    background-size: 100% 100%;
    background-attachment: fixed;

    color: var(--primary-color);
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }



  a {
    color: inherit;
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #000;
  }
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(var(--gradient-purple), var(--gradient-pink));
    border-radius: 10px;
  }
`;
